export default __webpack_public_path__ + "static/media/arrow-straight-small.d35f3802.svg";